import React from "react";

const Modal = ({ children, handleModalClose }) => {
  return (
    <div
      className="fixed top-0 left-0 bg-[#b3b3b329] w-full h-full flex items-center justify-center backdrop-blur-sm z-10"
      onClick={handleModalClose}
    >
      <div className="modalContent" onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
};

export default Modal;
